import { createApi } from '@reduxjs/toolkit/query/react';

import { IInviteUser, IUser } from '@/types/user';
import { TUpdateUserPayload } from '@/types/users';

import { baseQueryWithReauth } from './utils';

export const userApi = createApi({
  reducerPath: 'userApi',
  baseQuery: baseQueryWithReauth,
  endpoints: (build) => ({
    getUserMe: build.query<IUser, void>({
      query: () => ({
        url: 'user/me',
        method: 'GET',
      }),
    }),
    inviteUser: build.mutation({
      query: (params: IInviteUser) => ({
        url: 'user',
        method: 'POST',
        body: params,
      }),
    }),
    getUsers: build.query({
      query: (params: { page: number; limit: number; search?: string; customerId?: string }) => ({
        url: 'user/get-users',
        method: 'POST',
        body: { ...params, search: params.search || '' },
      }),
    }),
    updateUser: build.mutation({
      query: (user: TUpdateUserPayload) => {
        const body: Record<string, unknown> = { userId: user.userId };

        if (user.email !== undefined) {
          body.email = user.email;
        }
        if (user.fullName !== undefined) {
          body.fullName = user.fullName;
        }
        if (user.role !== undefined) {
          body.role = user.role;
        }

        return {
          url: 'user',
          method: 'PATCH',
          body,
        };
      },
    }),
    deleteUser: build.mutation({
      query: (params: { referenceId: string }) => ({
        url: 'user',
        method: 'DELETE',
        params,
        responseHandler: (response) => response.text(),
      }),
    }),
    toggleActiveUser: build.mutation({
      query: (referenceId: string) => ({
        url: 'user/toggle-active',
        method: 'PATCH',
        params: { referenceId },
      }),
    }),
  }),
});

export const {
  useGetUserMeQuery,
  useInviteUserMutation,
  useLazyGetUsersQuery,
  useGetUsersQuery,
  useDeleteUserMutation,
  useToggleActiveUserMutation,
  useUpdateUserMutation,
} = userApi;
